import { createSlice } from "@reduxjs/toolkit";

const savedLang = localStorage.getItem("lang");

const initialState = {
  lang: savedLang === "en" || savedLang === "vi" ? savedLang : "en",
};

const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action) => {
      state.lang = action.payload;
      localStorage.setItem("lang", action.payload);
    },
    toggleLanguage: (state) => {
      state.lang = state.lang === "en" ? "vi" : "en";
      localStorage.setItem("lang", state.lang);
    },
  },
});

export const { setLanguage, toggleLanguage } = languageSlice.actions;
export default languageSlice.reducer;
